import { useState } from 'react';
import DashboardLayout from '../../components/layout/DashboardLayout';
import { useAuth } from '../../context/AuthContext';
import api from '../../utils/api';

export default function TutorSettings() {
  const { user } = useAuth();
  const [profile, setProfile] = useState({ first_name:user?.first_name||'', last_name:user?.last_name||'', phone:user?.phone||'' });
  const [passwords, setPasswords] = useState({ current:'', newPw:'', confirm:'' });
  const [saving, setSaving]     = useState(false);
  const [savingPw, setSavingPw] = useState(false);
  const [msg, setMsg]     = useState('');
  const [pwMsg, setPwMsg] = useState('');

  const saveProfile = async () => {
    setSaving(true); setMsg('');
    try {
      await api.put('/auth/profile', profile);
      setMsg('success:Profile updated');
    } catch(err) { setMsg('error:' + (err.response?.data?.message||'Failed')); }
    setSaving(false);
  };

  const changePw = async () => {
    if (passwords.newPw !== passwords.confirm) return setPwMsg('error:Passwords do not match');
    if (passwords.newPw.length < 8) return setPwMsg('error:Minimum 8 characters');
    setSavingPw(true); setPwMsg('');
    try {
      await api.post('/auth/change-password', { currentPassword:passwords.current, newPassword:passwords.newPw });
      setPwMsg('success:Password changed successfully');
      setPasswords({ current:'', newPw:'', confirm:'' });
    } catch(err) { setPwMsg('error:' + (err.response?.data?.message||'Failed')); }
    setSavingPw(false);
  };

  const msgType = (m) => m.startsWith('success:') ? 'alert-success' : 'alert-error';
  const msgText = (m) => m.replace(/^(success|error):/, '');

  return (
    <DashboardLayout title="Settings">
      <div style={{maxWidth:540,display:'flex',flexDirection:'column',gap:16}}>
        <div className="card">
          <h3 style={{marginBottom:16,fontSize:'1rem'}}>Account details</h3>
          {msg && <div className={'alert ' + msgType(msg)} style={{marginBottom:16}}>{msgText(msg)}</div>}
          <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12,marginBottom:12}}>
            <div className="form-group" style={{margin:0}}>
              <label className="form-label">First name</label>
              <input type="text" className="form-input" value={profile.first_name} onChange={e=>setProfile({...profile,first_name:e.target.value})}/>
            </div>
            <div className="form-group" style={{margin:0}}>
              <label className="form-label">Last name</label>
              <input type="text" className="form-input" value={profile.last_name} onChange={e=>setProfile({...profile,last_name:e.target.value})}/>
            </div>
          </div>
          <div className="form-group">
            <label className="form-label">Phone</label>
            <input type="tel" className="form-input" value={profile.phone} onChange={e=>setProfile({...profile,phone:e.target.value})}/>
          </div>
          <div className="form-group">
            <label className="form-label">Email</label>
            <input type="email" className="form-input" value={user?.email||''} disabled style={{opacity:0.6}}/>
          </div>
          <button className="btn btn-primary" onClick={saveProfile} disabled={saving}>{saving?'Saving...':'Save changes'}</button>
        </div>

        <div className="card">
          <h3 style={{marginBottom:16,fontSize:'1rem'}}>Change password</h3>
          {pwMsg && <div className={'alert ' + msgType(pwMsg)} style={{marginBottom:16}}>{msgText(pwMsg)}</div>}
          <div className="form-group">
            <label className="form-label">Current password</label>
            <input type="password" className="form-input" value={passwords.current} onChange={e=>setPasswords({...passwords,current:e.target.value})}/>
          </div>
          <div className="form-group">
            <label className="form-label">New password</label>
            <input type="password" className="form-input" value={passwords.newPw} onChange={e=>setPasswords({...passwords,newPw:e.target.value})}/>
          </div>
          <div className="form-group">
            <label className="form-label">Confirm new password</label>
            <input type="password" className="form-input" value={passwords.confirm} onChange={e=>setPasswords({...passwords,confirm:e.target.value})}/>
          </div>
          <button className="btn btn-primary" onClick={changePw} disabled={savingPw}>{savingPw?'Changing...':'Change password'}</button>
        </div>

        <div className="card">
          <h3 style={{marginBottom:12,fontSize:'1rem'}}>Your public profile</h3>
          <p style={{fontSize:'0.875rem',color:'var(--ink-500)',marginBottom:12}}>See how parents see your profile</p>
          <a href={'/tutor/' + user?.slug} target="_blank" rel="noopener noreferrer" className="btn btn-secondary btn-sm">
            View my public profile
          </a>
        </div>
      </div>
    </DashboardLayout>
  );
}
